var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41,
    r: 41,
    fill: "#ECFDF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 41.5,
    r: 31.5,
    fill: "#A6F4C5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41,
    r: 22,
    fill: "#12B76A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 31.25C36.115 31.25 31.75 35.615 31.75 41C31.75 46.385 36.115 50.75 41.5 50.75C46.885 50.75 51.25 46.385 51.25 41C51.25 35.615 46.885 31.25 41.5 31.25ZM42.25 35C42.25 34.8011 42.171 34.6103 42.0303 34.4697C41.8897 34.329 41.6989 34.25 41.5 34.25C41.3011 34.25 41.1103 34.329 40.9697 34.4697C40.829 34.6103 40.75 34.8011 40.75 35V41C40.75 41.414 41.086 41.75 41.5 41.75H46C46.1989 41.75 46.3897 41.671 46.5303 41.5303C46.671 41.3897 46.75 41.1989 46.75 41C46.75 40.8011 46.671 40.6103 46.5303 40.4697C46.3897 40.329 46.1989 40.25 46 40.25H42.25V35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.380abbca702874ef0690de7256184562.svg";
export { ForwardRef as ReactComponent };